<template>
    <div class="module-wrap module-atlas" :mapData="mapData">
      <h2 v-html="moduleTitle"></h2>
      <div class="map-wrap"></div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleKnowlegeAtlas',
  props: ['moduleTitle', 'mapData'],
  data() {
    return {

    };
  },
  mounted() {
    // this.initData()
  },
  watch: {
    kdaData(val) {
      this.initData();
    },
  },
  methods: {
    async initData() {
      const that = this;
      const res = await this.mapData;
      // if(res && res.kda_table !==''){
      //   console.log(res)
      //   res.kda_table.forEach(function (v) {
      //     if (v['kda']) {
      //       that.kda.push(v.kda)
      //       that.kda_count.push(v.kda_count)
      //     }
      //   })
      //   this.renderBar(document.getElementById('myBar'), this.kda, this.kda_count)
    },
  },
};
</script>

<style lang="scss" scoped>
h2{
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.map-wrap{
  width: 620px;
  height: 400px;
  background: #D9F4FF;
  margin: 0 auto;
}
</style>
